import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../models/event";
import { EventType } from "../../../models/event-type";
import {Field} from "../../../models/field";
import {RoleControllerService} from "../../../services/role-controller/role-controller.service";
import { BaseError } from "../base-error";

@Component({
  selector: "fields-generator",
  templateUrl: "./fields-generator.component.html",
  providers: [RoleControllerService],
})
export class FieldsGeneratorComponent extends BaseError implements OnInit {
  @Input() public embedded: boolean = false;
  @Output() public modalClosedEvent = new EventEmitter();
  public serviceId: string;
  public rows = [];
  public editing = {};
  public fieldName;
  public fieldType;
  public fieldRequired;
  public max;
  public fields: Field[] = [];

  constructor(private roleControllerService: RoleControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
  }

  public updateValue(event, cell, rowIndex) {
    this.editing[rowIndex + "-" + cell] = false;
    this.rows[rowIndex][cell] = typeof event === "object" ? event.target.value : event;
    this.rows = [...this.rows];
  }

    public addNewField() {
      if (this.fieldName) {
          if (!this.fieldType) {
              this.fieldType = "text";
          }
          if (!this.max || this.max < 0) {
              this.max = 0;
          }
          if (!this.fieldRequired) {
              this.fieldRequired = false;
          }
          const field = {
              fieldName: this.fieldName,
              fieldType: this.fieldType,
              fieldRequired: this.fieldRequired === 1 ? true : false,
              max: this.max,
          };
          this.rows.push(field);
          this.rows = [...this.rows];
          this.emptyFields();
      }
    }

    public emptyFields() {
      this.fieldName = "";
      this.fieldType = "";
      this.max = "";
      this.fieldRequired = "";
    }

    public generateForm() {
      if (this.rows && this.rows.length > 0) {
          this.rows.forEach((f) => {
              const field = new Field();
              field.fieldName = f.fieldName;
              field.fieldType = f.fieldType;
              field.fieldRequired = f.fieldRequired;
              field.max = f.max;
              this.fields.push(field);
          });
          this.generateDefaultApplicantFormAndDataMapping();
      }
    }

    public generateDefaultApplicantFormAndDataMapping() {
        this.roleControllerService.generateDefaultApplicantForm(this.serviceId, this.fields).subscribe(
            () => {
                this.responseSuccessful("Default new applicant form generated successfully!");
            },
            (error) => this.showErrorMessageWithTitle("Unable to generate default applicant forms!", error),
        );
    }

  public cancel() {
    this.modalClosedEvent.emit(new Event(null, EventType.Cancel));
  }
}
